import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Button from '@vtex/styleguide/lib/Button'

import Icon from '@/checkout-instore-legacy/components/Commons/Icons'
import { withMediaQuery } from '@/checkout-instore-legacy/utils/mediaQuery'

const ModalScanAlert = ({ onCancel, mediaQuery }) => {
  const isDesktop = mediaQuery({
    phone: false,
    tablet: false,
    desktop: true,
  })

  return (
    <div>
      <div className="flex justify-center mt7">
        <Icon type="scanIndicator" />
      </div>
      <div className="flex justify-center mt6">
        <FormattedMessage id="couponPleaseScan" />
      </div>
      <div className="flex justify-center mt8">
        <Button
          id="couponScan"
          type="button"
          variation="secondary"
          onClick={onCancel}
          block={!isDesktop}
        >
          <FormattedMessage id="cancelScan" />
        </Button>
      </div>
    </div>
  )
}

ModalScanAlert.propTypes = {
  onCancel: PropTypes.func.isRequired,
  mediaQuery: PropTypes.func.isRequired,
}

export default withMediaQuery(ModalScanAlert)
